module.exports = __webpack_public_path__ + "img/SC-PROOF-1999.9b08dfd4.png";